import { render, staticRenderFns } from "./UnsubscribeEmailNotifications.vue?vue&type=template&id=1206f781&scoped=true"
import script from "./UnsubscribeEmailNotifications.vue?vue&type=script&lang=js"
export * from "./UnsubscribeEmailNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1206f781",
  null
  
)

export default component.exports